import React, { useCallback, useContext, useMemo } from 'react';
import { Trans } from '@lingui/macro';
import { BasicData } from '@App';
import './style.scss';
import { getModeLabel, formatMobileDate, getTextColorClass, getColor } from '@utils/Utils';

const formatNights = (nights) => {
    if (nights === 0 || nights == null) return '';
    return nights === 1 ? (<>{nights} <Trans>Night</Trans></>) : (<>{nights} <Trans>Nights</Trans></>);
};

const firstRowClass = (index) => (index === 0 ? 'first-row' : '');

const OverviewTimelineRow = ({ rows }) => {
    const { theme } = useContext(BasicData);
    const colors = useMemo(() => getColor(theme), [theme]);

    const getRouteTypeLabel = useCallback((type) => {
        switch (type) {
            case 'CheckIn':
                return <Trans>Check in</Trans>;
            case 'CheckOut':
                return <Trans>Check out</Trans>;
            case 'Stay':
                return <Trans>Stay</Trans>;
            default:
                return type;
        }
    }, []);

    return (
        <div className="ot-content">
            <div className="ot-rows">
                {rows.map((row, index) => (
                    <React.Fragment key={index}>
                        {(row.type === 'OvernightTravel' || row.type === 'OwnArrangement') && (
                            <div className={`ot-row ${firstRowClass(index)}`}>
                                <div className="ot-spacer" />
                                <div className="ot-elements">
                                    <div className="ot-element-wrapper">
                                        <div className="ot-date-mobile">{rows.length === 1 ? row.startDate && <>{formatMobileDate(row.startDate)}</> : <></>} </div>
                                        <div className="ot-date">{rows.length === 1 ? row?.startDate : <></>}</div>
                                        <div className="ot-time" />
                                        <div className="ot-route">
                                            <div className="dot accent">{row.label}</div>
                                        </div>
                                        <div className="ot-route-info" />
                                        <div className="ot-info">
                                            <div>{formatNights(row.nights)}</div>
                                            {row.basis &&
                                                <div>
                                                    <Trans>Basis</Trans>: {row.basis}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {row.type === 'Carhire' && (
                            <div className={`ot-row carhire ${firstRowClass(index)}`}>
                                <div className="ot-spacer" />
                                <div className="ot-elements">
                                    <div className="ot-element-wrapper">
                                        <div className="ot-date-mobile">{row.startDate && <>{formatMobileDate(row.startDate)}</>}</div>
                                        <div className="ot-date">{row?.startDate ? row.startDate : row?.endDate}</div>
                                        <div className="ot-time" />
                                        <div className="ot-route">
                                            <div className="time">{row?.startTime ? row.startTime : row?.endTime}</div>
                                            <div className="dot">{row.label}</div>
                                        </div>
                                        <div className="ot-route-info">
                                            {row.from && <>{row.from}</>}
                                            {row.to && <>{row.to}</>}
                                        </div>
                                        <div className="ot-info">{row.agency}</div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {row.type === 'Mobile' && (
                            <div className={`ot-row ${firstRowClass(index)}`}>
                                <div className="ot-spacer" />
                                <div className="ot-elements mobile-checkin">
                                    <div className="ot-element-wrapper">
                                        <div className="ot-date-mobile">{row.startDate && <>{formatMobileDate(row.startDate)}</>}</div>
                                        <div className="ot-date">{row?.startDate}</div>
                                        <div className="ot-time">{row?.startTime}</div>
                                        <div className="ot-route">
                                            <div className="dot accent">{row.accommodation}</div>
                                        </div>
                                        <div className="ot-route-info" />
                                        <div className="ot-info">{formatNights(row.nights)}</div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {row.type === 'Stop' && (
                            <div className={`ot-row ${firstRowClass(index)}`}>
                                <div className="ot-spacer" />
                                <div className="ot-elements">
                                    <div className="ot-element-wrapper">
                                        <div className="ot-date-mobile">{row.startDate && <>{formatMobileDate(row.startDate)}</>}</div>
                                        <div className="ot-date" />
                                        <div className="ot-time" />
                                        <div className="ot-route stop">
                                            <div className="pin">
                                                <div className="ot-pin-wrapper">
                                                    <i className="icon icon-pin-solid" />
                                                    <span className={`${getTextColorClass(`#${colors.accent}`)}`}>{row.pinLetter}</span>
                                                </div>
                                                <p>
                                                    <Trans id={row.type} values={row.type} /> <span>{row.label}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="ot-route-info" />
                                        <div className="ot-info">
                                            <div>{formatNights(row.nights)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {['StopArrival', 'StopDeparture'].includes(row.type) && (
                            <div className={`ot-row ${firstRowClass(index)}`}>
                                <div className="ot-spacer" />
                                <div className="ot-elements">
                                    <div className="ot-element-wrapper  mobile-accommodation">
                                        <div className="ot-date-mobile">{row.startDate && <>{formatMobileDate(row.startDate)}</>}</div>
                                        <div className="ot-date">{row.startDate}</div>
                                        <div className="ot-time" />

                                        {row.type === "StopArrival"
                                            ? <div className="ot-route stop">
                                                <div className="pin">
                                                    <div className="ot-pin-wrapper">
                                                        <i className="icon icon-pin-solid" />
                                                        <span className={`${getTextColorClass(`#${colors.accent}`)}`}>{row.pinLetter}</span>
                                                    </div>
                                                    <p>
                                                        {row.nights > 0 ? <><Trans>Overnight</Trans> {row.label}</> : <><Trans>Day stop</Trans> {row.label}</>}
                                                    </p>
                                                </div>
                                            </div>
                                            : <div className="ot-route">

                                                <div className="ot-route-mobile">
                                                    <div className="ot-mobile-mode">
                                                        <Trans>Stop departure</Trans>
                                                    </div>
                                                    <div className="ot-mobile-accommodation">{row.accommodation}</div>
                                                    <div className="ot-mobile-nights">{formatNights(row.nights)}</div>
                                                </div>
                                                <div className="dot accent"><Trans>Depart</Trans> {row.label}</div>
                                            </div>
                                        }

                                        <div className="ot-route-info" />
                                        <div className="ot-info">
                                            <div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {['CheckIn', 'Stay'].includes(row.type) && (
                            <div className={`ot-row ${firstRowClass(index)} stay`}>
                                <div className="ot-spacer" />
                                <div
                                    className={`ot-elements ${(row.type === 'Stay' || row.type === 'CheckIn') && row.pendingCheckout ? 'pending-checkout' : ''
                                        } ${['CheckIn', 'Stay'].includes(row.type) ? 'check-in' : ''}`}
                                >
                                    <div className="ot-element-wrapper">
                                        <div className="ot-date-mobile">{row.startDate && <>{formatMobileDate(row.startDate)}</>}</div>
                                        <div className="ot-date">{row.startDate}</div>
                                        <div className="ot-time" />
                                        <div className="ot-route">
                                            <div className="ot-route-mobile">
                                                <div className="ot-mobile-mode">
                                                    <Trans>Accommodation</Trans>
                                                </div>
                                                <div className="ot-mobile-accommodation">{row.accommodation}</div>
                                                <div className="ot-mobile-nights">{formatNights(row.nights)}</div>
                                            </div>
                                            <div className="pin">
                                                <div className="time">{row?.checkInTime}</div>
                                                <div className="ot-pin-wrapper">
                                                    <i className="icon icon-pin-solid" />
                                                    <span className={`${getTextColorClass(`#${colors.accent}`)}`}>{row.pinLetter}</span>
                                                </div>
                                                <span>{row.label}</span>
                                                <div className="ot-route-mobile">
                                                    <div>{getRouteTypeLabel(row.type)}</div>
                                                </div>
                                                {row.alternatives?.length > 0 && (
                                                    <div className="ot-alternatives">
                                                        <Trans>View Alternatives</Trans>
                                                        <div className="ot-alternatives-tooltip">
                                                            <ul>
                                                                <li>{row.accommodation}</li>
                                                                {row.alternatives.map((altName, altIndex) => (
                                                                    <li key={altIndex}>{altName}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="ot-route-info">
                                            <div>{getRouteTypeLabel(row.type)}</div>
                                        </div>
                                        <div className="ot-info">
                                            <div>{formatNights(row.nights)}</div>
                                            {row.basis &&
                                                <div>
                                                    <Trans>Basis</Trans>: {row.basis}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {row.type === 'CheckOut' && (
                            <div className={`ot-row ${firstRowClass(index)}`}>
                                <div className="ot-spacer" />
                                <div className={`ot-elements ${row.type === 'CheckOut' ? 'check-out' : ''}`}>
                                    <div className="ot-element-wrapper">
                                        <div className="ot-date-mobile">{row.startDate && <>{formatMobileDate(row.startDate)}</>}</div>
                                        <div className="ot-date">{row.startDate}</div>
                                        <div className="ot-time">
                                            <div className="time">{row?.startTime}</div>
                                        </div>
                                        <div className="ot-route">
                                            <div className="time">{row?.checkOutTime}</div>
                                            <div className="dot accent">{row.label}</div>
                                            <div className="ot-route-mobile">
                                                <div>{getRouteTypeLabel(row.type)}</div>
                                            </div>
                                        </div>
                                        <div className="ot-route-info">
                                            <div>{getRouteTypeLabel(row.type)}</div>
                                        </div>
                                        <div className="ot-info" />
                                    </div>
                                </div>
                            </div>
                        )}

                        {['Route', 'RouteStart', 'RouteEnd'].includes(row.type) &&
                            row.legType !== "Mobile" && (
                                <div className={`ot-row ${firstRowClass(index)}`}>
                                    <div className="ot-spacer" />
                                    <div className={`ot-elements ${row.startLabel && row.endLabel ? 'linked' : ''}`}>
                                        <div className="ot-element-wrapper route-start">
                                            <div className="ot-date-mobile">{row.startDate && <>{formatMobileDate(row.startDate)}</>}</div>
                                            <div className="ot-date">{row.startDate}</div>
                                            <div className="ot-time" />
                                            <div className="ot-route">
                                                <div className="ot-route-mobile">
                                                    <div className="ot-mobile-mode">{getModeLabel(row.mode)}</div>
                                                    {['ScheduledFlight', 'CharterFlight', 'Boat', 'Train', 'BoatNoRoute', 'TrainNoRoute'].includes(row.mode)
                                                        ? <div className='break-words'>
                                                            {row.agency} {row.vehicle && <span className='bold'>- {row.vehicle}</span>} {row.ticketClass ? `(${row.ticketClass})` : ""} <br />
                                                        </div>
                                                        : <>
                                                            <div>
                                                                {row.agency}
                                                            </div>

                                                            {row.vehicle &&
                                                                <div className='break-words'>
                                                                    {row.vehicle}
                                                                </div>
                                                            }
                                                        </>
                                                    }
                                                    {row.endTerminal && (
                                                        <div className="ot-mobile-terminal">{row.endTerminal}</div>
                                                    )}
                                                    <div className="ot-mobile-nights break-words">{row.referenceCodes ? <><Trans>Ref</Trans>: {row.referenceCodes}</> : ""}</div>
                                                </div>
                                                <div className="link-start">
                                                    <div className="time">{row?.startTime}</div>
                                                    <div className="dot">{row.startLabel}</div>
                                                </div>
                                            </div>
                                            <div className="ot-route-info">
                                                {row.startTerminal && (
                                                    <div className="start-terminal">{row.startTerminal}</div>
                                                )}
                                            </div>
                                            <div className="ot-info">
                                                {['ScheduledFlight', 'CharterFlight', 'Boat', 'Train', 'BoatNoRoute', 'TrainNoRoute'].includes(row.mode)
                                                    ? <div>
                                                        {row.agency} {row.ticketClass ? `(${row.ticketClass})` : ""} <br />
                                                        {row.vehicle &&
                                                            <span className='bold'>{row.vehicle}</span>
                                                        }
                                                    </div>
                                                    : <>
                                                        <div>
                                                            {row.agency}
                                                        </div>

                                                        {row.vehicle &&
                                                            <div>
                                                                {row.vehicle}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                <div className='break-words'>{row.referenceCodes ? <><Trans>Reference No</Trans>: {row.referenceCodes}</> : ""}</div>
                                            </div>
                                        </div>

                                        <div className="ot-element-wrapper route-end">
                                            <div className="ot-date-mobile">{row.startDate && <>{formatMobileDate(row.startDate)}</>}</div>
                                            <div className="ot-date" />
                                            <div className="ot-time" />
                                            <div className="ot-route">
                                                <div className="time">{row?.endTime}</div>
                                                <div className="link-end">
                                                    <div className="dot">{row.endLabel}</div>
                                                </div>
                                            </div>
                                            <div className="ot-route-info">
                                                {row.endTerminal && (
                                                    <div className="end-terminal">{row.endTerminal}</div>
                                                )}
                                            </div>
                                            <div className="ot-info"></div>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default OverviewTimelineRow;
